/* eslint-disable */
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';
import throwThemeInvalidWidthStepError from '../../../Errors/Theme/ThemeInvalidWidthStep.error';
import themeStepGet from '../StepGet/ThemeStepGet.support';

/**
 * Determine if the current `step` is larger than the provided one
 * @export
 * @param {EntryBreakpoints} breakpoints The breakpoints name for the `entry`
 * @param {WidthStep} stepToCheck The `step` to compare against the current
 * @param {boolean} [inclusive=true] Whether or not the `step` should be inslusive of `unit`'s
 * @returns {boolean} Whether or not the provided `step` is larger
 */
const themeStepUp = (breakpoints = throwParameterRequiredError(`breakpoints`), stepToCheck = throwParameterRequiredError(`step`), inclusive = true) => {
  const step = themeStepGet(breakpoints);
  const foundStepIndex = breakpoints.findIndex((breakpoint) => breakpoint.step === step);
  if (foundStepIndex === -1) {
    return throwThemeInvalidWidthStepError(step);
  }
  const foundStepToCheckIndex = breakpoints.findIndex((breakpoint) => breakpoint.step === stepToCheck);
  if (foundStepToCheckIndex === -1) {
    return throwThemeInvalidWidthStepError(stepToCheck);
  }
  if (inclusive) {
    return foundStepIndex > foundStepToCheckIndex;
  }
  return foundStepIndex >= foundStepToCheckIndex;
};

export default themeStepUp;
